import { cn } from '../cn';

export type Position = 'tl' | 'tc' | 'tr' | 'ml' | 'mc' | 'mr' | 'bl' | 'bc' | 'br';
export const POSITIONS: Position[] = ['tl', 'tc', 'tr', 'ml', 'mc', 'mr', 'bl', 'bc', 'br'];

export interface PositionGridProps {
  value: Position;
  onChange: (p: Position) => void;
  className?: string;
}

/** 3 × 3 caption anchor: 28 px cells / 4 px gap (mobile 36 / 5); selected = fg fill, others bg2 + border2. */
export function PositionGrid({ value, onChange, className }: PositionGridProps) {
  return (
    <div role="radiogroup" aria-label="Caption position" className={cn('grid flex-none grid-cols-[repeat(3,36px)] gap-[5px] md:grid-cols-[repeat(3,28px)] md:gap-1', className)}>
      {POSITIONS.map((p) => (
        <button
          key={p}
          type="button"
          role="radio"
          aria-checked={value === p}
          aria-label={p}
          onClick={() => onChange(p)}
          className={cn('h-9 w-9 rounded-md p-0 md:h-7 md:w-7 md:rounded-[5px]', value === p ? 'border-0 bg-fg' : 'border border-border2 bg-bg2 hover:border-fg4')}
        />
      ))}
    </div>
  );
}

export const positionToAlign = (p: Position) => ({
  v: ({ t: 'top', m: 'middle', b: 'bottom' } as const)[p[0] as 't' | 'm' | 'b'],
  h: ({ l: 'left', c: 'center', r: 'right' } as const)[p[1] as 'l' | 'c' | 'r'],
});
export const alignToPosition = (v: 'top' | 'middle' | 'bottom', h: 'left' | 'center' | 'right'): Position => `${v[0]}${h[0]}` as Position;
